<button [ngClass]="cssClass" data-crlat="showAllButton">
    @if (spinnerVisible) {
        <span class="btn-spinner" data-crlat="spinner.loader"></span>
    }
    <span [textContent]="getText()"></span>
</button>
